import { render, staticRenderFns } from "./MediaPost.vue?vue&type=template&id=00952054&scoped=true&"
import script from "./MediaPost.vue?vue&type=script&lang=js&"
export * from "./MediaPost.vue?vue&type=script&lang=js&"
import style0 from "./MediaPost.vue?vue&type=style&index=0&id=00952054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00952054",
  null
  
)

export default component.exports